import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getAuth, confirmPasswordReset } from "firebase/auth";
import { TextField, Button, Typography, Container, Alert } from "@mui/material";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Extract reset code (oobCode) from URL
  const oobCode = searchParams.get("oobCode");

  useEffect(() => {
    if (!oobCode) {
      setError("Invalid password reset link.");
    }
  }, [oobCode]);

  const handleResetPassword = async () => {
    setError("");
    setSuccess("");

    if (!oobCode) {
      setError("Invalid or expired password reset link.");
      return;
    }

    try {
      const auth = getAuth();
      await confirmPasswordReset(auth, oobCode, newPassword);
      setSuccess("Password successfully reset! Redirecting to login...");

      // Redirect to login page after a few seconds
      setTimeout(() => {
        navigate("/"); // Redirects to the main page where login logic exists
      }, 3000);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        Reset Your Password
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}

      <TextField label="New Password" type="password" fullWidth sx={{ mt: 2 }} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />

      <Button variant="contained" color="primary" fullWidth sx={{ mt: 2 }} onClick={handleResetPassword}>
        Reset Password
      </Button>
    </Container>
  );
};

export default ResetPassword;
